import { FormControlLabel, Radio } from "@mui/material";
import { TributesInfo } from "components/CreateMemorialQuiltComponents/TributesSection/components/TributesInfo";
import styles from './styles.module.scss';
import { setEditableQuiltState } from "store/reducers/quiltSlice";
import { useAppDispatch, useAppSelector } from "hooks";
import { useTranslates } from "providers/translates";
import { enabledTributesAndCondolences } from "api/http-client/queries/memorials";

type Props = {
  setLoading: (value: boolean) => void;
}

export const TributesSection: React.FC<Props> = ({
  setLoading
}) => {
  const { translates: t } = useTranslates();
  const tributesPermissions = t?.quiltBuilderStepOne?.tributesPermissions;
  const dispatch = useAppDispatch();
  const editableQuiltStore = useAppSelector((state) => state.quilt.editableQuilt);

  const setIsEnableTributesAndCondolence = async (event: any) => {
    if (!editableQuiltStore) return;

    try {
      setLoading(true);
      const updatedQuilt = {
        ...editableQuiltStore,
        isEnableTributesAndCondolence: !editableQuiltStore.isEnableTributesAndCondolence
      };

      await enabledTributesAndCondolences(
        editableQuiltStore.id as string, 
        !editableQuiltStore.isEnableTributesAndCondolence
      );
      dispatch(setEditableQuiltState(updatedQuilt));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.tributes}>
        <TributesInfo />

        <div className={styles.tributes__radio}>
          <FormControlLabel
            control={
              <Radio
                checked={editableQuiltStore?.isEnableTributesAndCondolence === true}
                onClick={setIsEnableTributesAndCondolence}
                value="true"
              />
            }
            componentsProps={{
              typography: {
                color: '#24476A',
                fontSize: { xs: '18px', sm: '22px' },
                fontFamily: 'Open Sans',
              },
            }}
            label={tributesPermissions?.tributesPermissionRadioButtonText ?? "Allow tributes and condolences"}            
          />
        </div>
      </div>
    </>
  );
}